export default __webpack_public_path__ + "static/media/sad-face.ce33e4da.png";